module.exports = __webpack_public_path__ + "img/pro_two_7.b247961a.jpg";